import { createFileRoute } from "@tanstack/react-router";
import DemoPositions from "src/pages/Link/Demo/DemoPositions";

export const Route = createFileRoute("/link/demo_/positions")({
	component: DemoPositions
});
